import { mapMutations, mapGetters, mapActions } from 'vuex'
import search from '@/mixins/search'

export default {
  mixins: [
    search
  ],
  data () {
    return {
      supportedParams: ['focus', 'direct', 'mode', 'id', 'events', 'departments', 'header', 'fullscreen', 'search', 'tag', 'vehicle', 'cache'],
      idMap: {
        2: '2085/87 Grand Avenue (SJV Grand)',
        1: '2057 Portland Avenue',
        6: '2109 Grand Avenue',
        7: '2110 Summit Avenue',
        8: '2117 Grand Avenue',
        9: '2130 Summit Avenue',
        10: '2134 Summit Avenue',
        11: '2140 Summit Avenue',
        12: '2143 Grand Avenue',
        13: '2144 Summit Avenue',
        14: '2150 Summit Avenue',
        15: '2151 Grand Avenue',
        16: '2154 Summit Avenue',
        17: '2156 Summit Avenue',
        18: '2159 Grand Avenue',
        19: '2163 Grand Avenue',
        20: '2166 Summit Avenue',
        22: 'John P. Monahan Plaza',
        23: '2171 Grand Avenue',
        24: '2174 Summit Avenue',
        25: '2175 Grand Avenue',
        26: '30 South Finn Street',
        27: '32 South Finn Street',
        28: '44 N. Cleveland Avenue',
        29: 'Admissions Office',
        30: 'Alumni and Constituent Relations',
        31: 'Anderson Athletic and Recreation Complex',
        32: 'Anderson Parking Facility',
        33: 'Anderson Student Center',
        34: 'Aquinas Hall',
        35: 'Archbishop Ireland Memorial Library',
        36: 'Binz Refectory',
        37: 'Brady Educational Center',
        38: 'Brady Hall',
        39: 'Byrne Residence',
        40: 'Chapel of St. Thomas Aquinas',
        41: 'Child Development Center',
        42: 'Cretin Hall',
        43: 'Development Office',
        44: 'Dowling Hall',
        45: 'Emergency Phone',
        46: 'Emergency Phone',
        47: 'Emergency Phone',
        48: 'Emergency Phone',
        49: 'Emergency Phone',
        50: 'Facilities & Design Center',
        51: 'Faculty Residence',
        52: 'Flynn Residence',
        53: 'Grace Hall',
        54: 'Greenhouse',
        55: 'Grotto',
        56: 'Ireland Hall',
        57: 'John Paul II Hall',
        58: 'John R. Roach Center for the Liberal Arts',
        59: 'Koch Commons',
        60: 'Loras Hall',
        61: 'McCarthy Gymnasium',
        62: 'McNeely Hall',
        63: 'McNeely Parking Ramp',
        64: 'Morrison Hall',
        65: 'Morrison Ramp',
        66: 'Murray-Herrick Campus Center',
        67: 'North Athletic Fields',
        68: 'O\'Shaughnessy Educational Center',
        69: 'O\'Shaughnessy Science Hall',
        70: 'O\'Shaughnessy Stadium',
        71: 'O\'Shaughnessy-Frey Library Center',
        72: 'Opus Hall',
        73: 'Owens Science Hall',
        74: 'Palmer Athletic Field',
        75: 'Parking Lot A',
        76: 'Parking Lot B',
        77: 'Parking Lot C',
        78: 'Parking Lot D',
        79: 'Parking Lot E',
        80: 'Parking Lot G (Admissions Parking)',
        81: 'Parking Lot I',
        83: 'Parking Lot K (East)',
        84: 'Parking Lot K (West)',
        85: 'Parking Lot L',
        86: 'Parking Lot M',
        87: 'Parking Lot N',
        88: 'Parking Lot O',
        89: 'Parking Lot P1',
        90: 'Parking Lot P2',
        91: 'Parking Lot P3',
        92: 'Parking Lot P4',
        93: 'Parking Lot Q',
        94: 'Parking Lot U',
        95: 'Parking Lot V',
        96: 'Parking Lot X',
        97: 'Parking Lot Y',
        98: 'Parking Services (MHC LL17)',
        99: 'Parking at 11th Street and Harmon Place',
        100: 'Parking at Highland Bank Court US Bancorp Center ',
        101: 'Parking at Hilton Hotel',
        102: 'Parking at Lasalle Ave and 11th Street ',
        103: 'Parking at Lasalle Ave and 9th Street',
        104: 'Parking at Target store and RETEK Tower',
        105: 'Facilities Management',
        111: 'Public Safety',
        123: 'Sabo Plaza',
        124: 'School of Divinity, St. Paul Seminary',
        125: 'School of Law',
        126: 'Schulze Hall',
        127: 'Seminary Residence, St. Paul Seminary',
        128: 'Service Center',
        129: 'Sitzmann Hall',
        130: 'South Athletic Fields',
        131: 'St. John Vianney Seminary',
        132: 'St. Marys Chapel, St. Paul Seminary',
        133: 'Summit Classroom Building',
        134: 'Terrence Murphy Hall',
        135: 'West Metropolitan: Education Program',
        136: 'Fowler Veranda',
        137: '2139 Grand Avenue',
        160: 'Greenhouse',
        161: 'West Metropolitan: Education Program - Underground Parking Garage',
        162: 'Emergency Phone',
        163: 'Emergency Phone',
        164: 'Emergency Phone',
        165: 'Emergency Phone',
        166: 'Emergency Phone',
        167: 'Emergency Phone',
        168: 'Emergency Phone',
        169: 'Emergency Phone',
        170: 'Emergency Phone',
        171: 'Emergency Phone',
        172: 'Emergency Phone',
        173: 'Summit Ave & Finn St',
        174: 'Summit Ave & Cretin Ave',
        175: 'Cleveland Ave & Summit Ave',
        176: 'Grand Ave & Finn St',
        177: 'Grand Ave & Finn St',
        178: 'Summit Ave & Cleveland Ave',
        179: 'Summit Ave & Cretin Ave',
        180: 'Cretin Ave & Summit Ave',
        181: 'Cretin Ave & Summit Ave',
        182: 'Cleveland Ave & Portland Ave',
        183: 'Cleveland Ave & Grand Ave',
        184: 'Cleveland Ave & Grand Ave',
        185: 'Grand Ave & Cleveland Ave',
        186: 'Grand Ave & Cleveland Ave',
        187: 'Grand Ave & Cretin Ave',
        188: 'Grand Ave & Cretin Ave',
        189: 'Cleveland Ave & Ashland Ave/Portland Ave',
        190: 'Cleveland Ave & Ashland Ave',
        193: 'Cleveland Ave & Selby Ave',
        194: 'Cleveland Ave & Selby Ave',
        195: 'Cretin Ave & Selby Ave',
        196: 'Cretin Ave & Selby Ave',
        197: 'Summit Ave & Cretin Ave',
        198: 'Grand Ave & Finn St',
        // 'name':'Summit Ave & Finn St',
        199: 'Cleveland Ave & Selby Ave',
        200: 'University of St. Thomas Shuttle',
        201: '10th St S & LaSalle Ave',
        202: '10th St S & Harmon Place',
        203: '11th St S & La Salle Ave S',
        204: '11th St S & Harmon Place',
        205: '12th St S & Yale Place',
        206: 'University of St. Thomas Shuttle',
        207: 'Schoenecker Center'
      }
    }
  },
  computed: {
    ...mapGetters([
      'campuses'
    ])
  },
  methods: {
    ...mapActions([
      'setActiveLocations'
    ]),
    ...mapMutations([
      'setVehicle',
      'setStops',
      'setActiveCampus',
      'setTriggerValidation',
      'setFilteredTags'
    ]),
    async runRouterCompatibility () {
      const queries = Object.keys(this.$route.query).map(query => query.toLowerCase())

      queries.forEach(async query => {
        const queryValue = decodeURI(this.$route.query[query])

        switch (query) {
          case 'focus': {
            const campus = this.campuses.filter(campus => campus.code.toLowerCase() === queryValue.toLowerCase())

            if (campus.length) {
              this.setActiveCampus(campus[0])
            } else {
              const results = await this.search(queryValue)

              if (results.length > 0) {
                this.setActiveLocations(results)
              } else {
                console.error(`Unable to find location: ${queryValue}`)
              }
            }

            break
          }

          case 'direct': {
            const params = queryValue.split(';')
            const output = []
            let activeLocations = []

            params.forEach((param) => {
              // Check to see if the current iteration is a coordinate
              if (param.includes(',')) {
                output.push(new Promise((resolve, reject) => {
                  try {
                    const coordinates = param.split(',').map((coord) => parseFloat(coord))
                    resolve({
                      name: `${coordinates[0]},${coordinates[1]}`,
                      lat: coordinates[0],
                      lng: coordinates[1]
                    })
                  } catch (e) {
                    reject(e)
                  }
                }))
              } else {
                output.push(
                  this.search(param)
                    .then(results => {
                      if (results.length > 0) {
                        activeLocations = activeLocations.concat(results[0])
                        return results[0]
                      }
                    })
                )
              }
            })

            // Get all waypoints including coordinates
            const waypoints = await Promise.all(output)

            if (activeLocations.length) {
              // Get all waypoints not including coordinates and update our active locations
              this.setActiveLocations(activeLocations)
            }

            await this.$nextTick()

            // Move the app to the directions route
            this.$router.push({
              name: 'directions'
            })

            // Update the stops
            const stops = waypoints.map(location => {
              return {
                name: location.name,
                lat: location.lat,
                lng: location.lng
              }
            })
            this.setStops(stops)

            // Update the vehicle
            const vehicle = this.$route.query.mode || this.$route.query.vehicle
            if (vehicle) this.setVehicle(vehicle)

            // Trigger a validation if there's more than one stop
            if (stops.length > 1) {
              this.setTriggerValidation(true)
            }

            break
          }

          case 'id': {
            const name = this.idMap[queryValue]

            if (name) {
              const results = await this.search(name)

              if (results.length > 0) {
                this.setActiveLocations(results)
              } else {
                console.error(`Unable to find location: ${name}`)
              }
            } else {
              console.error(`Unable to find location: ${queryValue}`)
            }

            break
          }

          case 'events': {
            const results = await this.search(queryValue)

            if (results.length > 0) {
              this.setActiveLocations(results)
              this.$router.push({
                params: { mode: 'events' },
                query: Object.assign({}, this.$route.query, { events: undefined })
              })
            } else {
              console.error(`Unable to find location: ${queryValue}`)
            }

            break
          }

          case 'departments': {
            const results = await this.search(queryValue)

            if (results.length > 0) {
              this.setActiveLocations(results)
              this.$router.push({
                params: { mode: 'departments' },
                query: Object.assign({}, this.$route.query, { departments: undefined })
              })
            } else {
              console.error(`Unable to find location: ${queryValue}`)
            }

            break
          }

          case 'header': {
            this.$root.$emit('set-header', queryValue)

            break
          }

          default: {
            if (this.supportedParams.includes(query)) break

            const results = await this.search(query)

            if (results.length > 0) {
              this.setActiveLocations(results)

              results.forEach((result) => {
                this.$root.$emit('set-location-message', {
                  _id: result._id,
                  message: query
                })
              })
            } else {
              console.error(`Unable to find location: ${query}`)
            }

            break
          }
        }
      })
    }
  }
}
